export default __webpack_public_path__ + "static/media/901.9f5feac1.gif";